export default __webpack_public_path__ + "guard_on-25b5f8.mp3";